<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title title="修改密码"></pt-page-title>
    <pt-sub-title title="修改密码"></pt-sub-title>
    <password-form v-model="formValue" ref="form"></password-form>
    <el-button type="primary" @click="certain">提交</el-button>
    <el-button type="primary" plain @click="cancel">取消</el-button>
  </div>
</template>

<script>
import passwordForm from './form'
// 组件class前缀
const prefixCls = 'pt-edit-password'

export default {
  name: 'pt-edit-password',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    passwordForm
  },
  data () {
    return {
      loading: false,
      formValue: {}
    }
  },
  methods: {
    certain () {
      this.$refs.form.validate().then(_ => {
        this.loading = true
        this.$store.dispatch('changePassword', this.formValue).then(data => {
          this.loading = false
          this.$message.success('修改成功，请用新密码登录')
          history.go(-1)
        }).catch(err => {
          this.loading = false
          this.$message.error(err)
        })
      })
    },
    cancel () {
      window.history.go(-1)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
